import { fetchEventSource } from '@microsoft/fetch-event-source';

import axios from "axios";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import qs from "qs";
import store from "@/shared/store";
import cacheInterceptor from "@/shared/utils/cache-interceptors-service";

const baseURL = process.env.VUE_APP_JAVA_BASEURL+'/v2';
const $sse={}


const $javaHttp = axios.create({
  baseURL: baseURL,
  timeout: 50000
});
$javaHttp.interceptors.request.use(
  config => {
    NProgress.start();
    const _cache = cacheInterceptor.check(config);
    if (_cache) {
      NProgress.done();
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      config.cancelToken = source.token;
      source.cancel({
        cached: true,
        data: _cache
      });
    }
    let t = 'Bearer '

    config.baseURL = baseURL
    // console.log(config.baseURL)
    // console.log(process.env)
    // console.log(process.env.VUE_APP_JAVA_BASEURL)
   // config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    if (store.getters.isLogin) {
      config.headers['Authorization'] = t+store.state.token;
    }

    config.headers['L-IdentityType'] =  'G-IE';
    config.headers['Content-Type'] =  'application/json';
    
    if (config.method != "get") {
      config.data = config.data || {};
      // config.data.source = 'IE';
      config.data = config.data;
    } else {
      config.params = config.params || config.params;
      // config.params.source = 'IE';
    }
    return config;
  },

  err => {
    Promise.reject(err);
  }
);

$javaHttp.interceptors.response.use(
  response => {
    NProgress.done();
    if(response.config && response.config.responseType == 'arraybuffer') {
      return response.data
    }
    // if (response.data.code == "OK" || response.data.code == "SUCCESS" || response.data.code == "0") {
   if (response.data.code == "0") {
      cacheInterceptor.capture(response);
      return response.data.data;
    }  else {
      store.dispatch("pushMessage", response.data.message);
      return Promise.reject(response.data.message);
    }
  },
  err => {
    var a = { err };
    NProgress.done();
    if (err.__CANCEL__) {
      if (err.message.cached) {
        return Promise.resolve(err.message.data);
      }
    } else {
      store.dispatch("pushMessage", "网络超时，请稍后重试");
      return Promise.reject(err);
    }
  }
);
$sse.javaHttp = $javaHttp
//let se = null;
//const fetch = window.fetch.bind(window);
$sse.fetchsse = function(url,conversation,msg,cb,params = {}){
  console.log("--fetchsse")
  const abortController = new AbortController();
  
  let bodyParams = params;
  bodyParams.stream = true;
  bodyParams.conversation = conversation?conversation:undefined;
  bodyParams.message = msg?msg:undefined;

  fetchEventSource(baseURL+url, {
    method: 'POST',
      signal: abortController.signal,
      //config.headers['Authorization'] = store.state.token;
      headers: {
        'Content-Type': 'application/json',
         'L-IdentityType': 'G-IE',
          'Authorization': 'Bearer '+store.state.token,//eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiMiIsImV4cCI6MTY5NDkxOTk4NCwiZG9tYWluIjoiYXBwLmNvbHVtYnVzLmltODcuY24ifQ.uu9WIK2sew1PCG-Xjn7Yfo7xTdWAIArbPlUiW-gcBcA'
        // 'lucas_ie_userId:': 1001,
        // 'Lucas-Columbus-IE-UserId': 100,
        // 'devicetype': 'pc',
        // 'token': that.token
      },
      // body: JSON.stringify({
      //   "stream": true,
      //   "conversation":conversation?conversation:undefined,
      //   "message": msg,

      // }),
       body: JSON.stringify(bodyParams),
  
      async onopen(response) {
        //console.log('连接了');
        if (response.ok) {
          console.log('连接了');
        } else {			
        }
      },
      // onmessage(ev) {
      //  // console.log(ev.data);
      // },
       onmessage(msg) {
        console.log("onmessage")
        //console.log(msg)
        //console.log(msg.data)
        //console.log(JSON.parse(msg.data).data)
        //console.log(JSON.parse(msg.data).data.ai.msg)
       // console.log(JSON.parse(msg.data).data.ai.finish)
        let data = msg.data;
        data = JSON.parse(data)
        data = data.data;
        let conversation = data.conversation;
        let ai = data.ai;
        let finish = data.finish;
        let msg1 = ''
        if(finish != 1){
          //to do 关闭 这个好像不需要 ，没有方法
          msg1 = ai.msg;
        }
    
        if(cb)cb(conversation,finish==1,msg1);
      
        // if (msg.event === 'FatalError') {
        //  // throw new Error(msg.data);
        // }
        // if (msg.data !== '[DONE]') {
        // }
      },
      onclose() {	
      },
      onerror(err) {
        console.log(err)
        //throw new Error(err)
      }
    });
    
}

$sse.http = function(url,data,cb){

  url = 'http://localhost:8000/event?page='+this.page+'&pageSize='+this.pageSize+'&appId='+this.appId
  let es = new EventSource(url);
  es.addEventListener('message', event => {
      if(cb)cb(event.data)
      console.log(event.data);
  });
  es.addEventListener('error', event => {
      if (event.readyState == EventSource.CLOSED) {
          console.log('event was closed');
      };
  });
  es.addEventListener('close', event => {
      console.log(event.type);
      es.close();
  });
}
$sse.fetch = async function(){
  const response = await fetch('https://gateway-test.lucasgchr.com/v2/aitest/openai/bot/ie/chat', {
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      'L-IdentityType': 'G-IE',
       'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiMiIsImV4cCI6MTY5NDkxOTk4NCwiZG9tYWluIjoiYXBwLmNvbHVtYnVzLmltODcuY24ifQ.uu9WIK2sew1PCG-Xjn7Yfo7xTdWAIArbPlUiW-gcBcA'
     // 'lucas_ie_userId:': 1001,
     // 'Lucas-Columbus-IE-UserId': 100,
     // 'devicetype': 'pc',
     // 'token': that.token
    },
    body: 
    JSON.stringify({
      "stream": true,
      "message": "讲一个笑话"
  }),
  });

  if (!response.body) return;
  const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
  while (true) {
    var { value, done } = await reader.read();
    if (done) break;
    value = value.replace('undefined', '')
    console.log("received data -", value)
    //output.value += value.replace('undefined', '')
  }
}
export default $sse;
